/** Shared by every endpoint that produces a full session: login (authenticated case), `GET /api/me`, second-factor verification and enrollment confirmation. */
export type AuthenticatedUserPayload = {
	readonly id: number;
	readonly email: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly role: { readonly id: number } | null;
	readonly account: { readonly id: number } | null;
};

export type UserAuthenticatedAction = {
	type: 'USER_AUTHENTICATED';
	payload: AuthenticatedUserPayload;
};

export default (payload: AuthenticatedUserPayload): UserAuthenticatedAction => ({
	type: 'USER_AUTHENTICATED',
	payload,
});
